export const exceptionalHomesImages = [
    "/Slideshow/Exceptional Homes 1.png",
    "/Slideshow/Exceptional Homes 2.png",
    "/Slideshow/Exceptional Homes 3.png",
];

export const contactImages = [
    "/Slideshow/Contact 1.png",
    "/Slideshow/Contact 2.png",
    "/Slideshow/Contact 3.png",
];

export const aboutImages = [
    "/Slideshow/About Us 1.png",
    "/Slideshow/About Us 2.png",
    "/Slideshow/About Us 3.png",
];

export const materialsImages = [
    "/Slideshow/Materials 1.png",
    "/Slideshow/Materials 2.png",
    "/Slideshow/Materials 3.png",
];

export const constructionImages = [
    "/Slideshow/Construction 1.png",
    "/Slideshow/Construction 2.png",
    "/Slideshow/Construction 3.png",
];

export const luxuryImages = [
    "/Slideshow/Luxury 1.png",
    "/Slideshow/Luxury 2.png",
    "/Slideshow/Luxury 3.png",
]

export const designedImages = [
    "/Slideshow/Designed 1.png",
    "/Slideshow/Designed 2.png",
    "/Slideshow/Designed 3.png",
]